import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import compose from '../../hoc/compose';
import dropDownHelpers from '../../util/dropDownHelpers';
import dropDownPositionUtil from '../../util/dropDownPosition';
import { Option, Selected, SearchBox, SelectedTextContainer } from './dropDownChildren/dropDownChildren';
import KEYS from '../../common/keyCodes';
import { getRectByBoundingRect, getRectByReactElement, getStyleByRect } from '../../util/rect';
import DropDownBase from '../dropDownBase';
var wrapOption = dropDownHelpers.wrapOption;

var isSelected = function isSelected(val, curr) {
  return !_.isUndefined(val) && (val === curr || val === (curr && curr.value) || val === _.get(curr, 'props.value'));
};

var wrapOptionWithOptionComponent = wrapOption.bind(null, Option);

var getOptionsValue = function getOptionsValue(opt) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';

  if ( /*#__PURE__*/React.isValidElement(opt)) {
    return opt.props[key];
  }

  return _.isObject(opt) ? opt[key] : opt;
};

var getOptionWrapperClassName = function getOptionWrapperClassName(opt) {
  if (! /*#__PURE__*/React.isValidElement(opt) && !_.isObject(opt)) {
    return null;
  }

  return getOptionsValue(opt, 'optionWrapperClassName');
};

var getOptionsLabel = function getOptionsLabel(opt) {
  return getOptionsValue(opt, 'label');
};

var isOptionsDisabled = function isOptionsDisabled(opt) {
  if ( /*#__PURE__*/React.isValidElement(opt)) {
    return opt.props.disabled;
  }

  return _.isObject(opt) ? opt.disabled : false;
};

var isTermInOption = function isTermInOption(term, opt) {
  var searchable = getOptionsLabel(opt) || getOptionsValue(opt);
  return searchable && _.startsWith(searchable.toLowerCase(), term.toLowerCase());
};

var getHiddenScrollStyle = function getHiddenScrollStyle(node) {
  return {
    width: "calc(100% + ".concat(node.offsetWidth - node.clientWidth, "px)")
  };
};

var getSelectedKeyAndChild = function getSelectedKeyAndChild(selected, shouldRenderSearchBox) {
  if ( /*#__PURE__*/React.isValidElement(selected)) {
    return {
      key: selected.key,
      child: shouldRenderSearchBox ? selected.props.label || selected.props.value : selected
    };
  }

  var isStringOrFalsyValue = _.isString(selected) || !selected;
  return {
    key: isStringOrFalsyValue ? selected : selected.key || selected.label || selected.value,
    child: isStringOrFalsyValue ? selected : selected.label || selected.value
  };
};

var getNodeByRefIfExist = function getNodeByRefIfExist(node) {
  return node ? ReactDOM.findDOMNode(node) : null;
};

var DropDown = /*#__PURE__*/function (_React$Component) {
  _inherits(DropDown, _React$Component);

  var _super = _createSuper(DropDown);

  function DropDown(props) {
    var _this;

    _classCallCheck(this, DropDown);

    _this = _super.call(this, props);

    var updateValue = function updateValue(val) {
      var value = _this.props.value;
      var multiSelect = props.multiSelect;

      if (multiSelect) {
        return _.includes(value, val) ? _.filter(value, function (v) {
          return v !== val;
        }) : //may be _.remove
        [].concat(_toConsumableArray(value), [val]);
      }

      return val;
    };

    var onChangeValue = function onChangeValue(val) {
      var value = updateValue(val);

      if (_this.props.multiSelect) {
        _this.props.onChange(value);
      } else if (!isSelected(_this.props.value, val) || _this.props.callOnChangeAnyway) {
        _this.props.onChange(val);
      }
    };

    var onOptionClick = function onOptionClick(val) {
      onChangeValue(val);

      if (!_this.props.multiSelect) {
        _this.setState({
          isOpen: false,
          candidateIndex: _.indexOf(_this.getOptions(), _this.getSelected())
        });
      }
    };

    _this.getOptions = function () {
      var flatten = _this.props.groupedOptions ? _.flattenDeep : _.flatten;
      var children = _this.props.children && (_.isArray(_this.props.children) ? _this.props.children : [_this.props.children]);
      return _this.props.options || _.compact(flatten(children)) || [];
    };

    _this.findOption = function (val) {
      return _.find(_this.getOptions(), isSelected.bind(null, val));
    };

    _this.findOptions = function (values) {
      return _.map(values, _this.findOption);
    };

    _this.hasChildren = function () {
      return /*#__PURE__*/React.isValidElement(_this.getOptions());
    };

    _this.map = _this.hasChildren() ? React.Children.map : _.map;

    _this.getSelected = function () {
      return props.multiSelect ? _this.findOptions(_this.props.value) : _this.findOption(_this.props.value) || _this.props.placeholder || _this.getOptions()[0];
    };

    _this.onSelectedMount = function (ref) {
      _this.wrappedSelectedOption = ref;
    };

    _this.onActiveUpdate = function (ref) {
      _this.activeOption = ref;
    };

    _this.registerStickyFooter = function (ref) {
      _this.stickyFooter = ref;
    };

    _this.optionsRefs = [];
    _this.optionsY = [];

    _this.onOptionMount = function (index, ref) {
      _this.optionsRefs[index] = ref;
      _this.optionsY[index] = ReactDOM.findDOMNode(ref).offsetTop;
    };

    _this.onMouseEnter = function (option, candidateIndex) {
      if (props.onOptionMouseEnter) {
        props.onOptionMouseEnter(option);
      }

      _this.setState({
        candidateIndex: candidateIndex
      });
    };

    var isOptionSelected = function isOptionSelected(opt) {
      return props.multiSelect ? _.includes(_this.getSelected(), opt) : _this.getSelected() === opt;
    };

    _this.getOptionsElements = function () {
      if (props.multiSelect && _this.props.value.length === 0) {
        _this.wrappedSelectedOption = null;
      }

      return _this.map(_this.getOptions(), function (opt, index) {
        return wrapOptionWithOptionComponent({
          onClick: onOptionClick,
          // TODO: Performance improvement: Use candidateIndex state only for keys (UP/DOWN) and use hover and click for mouse
          onMouseEnter: function onMouseEnter() {
            return _this.onMouseEnter(opt, index);
          },
          shouldTranslate: _this.props.shouldTranslate,
          selected: isOptionSelected(opt),
          active: index === _this.state.candidateIndex,
          onSelectedMount: _this.onSelectedMount,
          onActive: _this.onActiveUpdate,
          key: opt.key || getOptionsValue(opt),
          onMount: _this.props.shouldPassIsVisibleToOptions ? function (ref) {
            _this.onOptionMount(index, ref);
          } : _.noop,
          isVisible: _this.props.shouldPassIsVisibleToOptions ? _.includes(_this.state.visibleOptionsIndexes, index) : null,
          wasVisible: _this.props.shouldPassIsVisibleToOptions ? _.includes(_this.state.wasVisibleOptionsIndexes, index) : null,
          registerStickyFooter: _this.registerStickyFooter,
          toggleOptions: _this.toggleOptions,
          multiSelect: _this.props.multiSelect,
          optionWrapperClassName: getOptionWrapperClassName(opt)
        }, opt);
      });
    };

    _this.getCloseKeys = function () {
      return _this.props.searchBox || _this.props.multiSelect ? [KEYS.ENTER, KEYS.ESC] : null;
    };

    _this.searchOption = function (term) {
      return _.find(_this.getOptions(), function (opt) {
        return isTermInOption(term, opt) && _this.getIsSelectableByIndex(_this.getOptions().indexOf(opt));
      });
    };

    _this.isLabelInOptions = function (label) {
      return _.some(_this.getOptions(), function (option) {
        return getOptionsLabel(option) === label;
      });
    };

    _this.onSearch = function (searchTerm, callback) {
      if (_this.props.allowAddExtraStringOptions && _this.props.onAddExtraStringOption && !_this.isLabelInOptions(searchTerm)) {
        _this.setState({
          candidateIndex: -1,
          foundOption: {
            label: searchTerm
          },
          isExtraLabel: true,
          searchTerm: searchTerm
        }, function () {
          _this.onActiveUpdate(null);
        });
      } else {
        var foundOption = searchTerm && _this.searchOption(searchTerm);

        var candidateIndex = foundOption ? _this.getOptions().indexOf(foundOption) : _this.state.candidateIndex;

        _this.setState({
          candidateIndex: candidateIndex,
          foundOption: foundOption,
          searchTerm: searchTerm,
          isExtraLabel: false
        }, function () {
          var enforce = true;

          _this.scrollToActive(enforce);

          if (_.isFunction(callback)) {
            callback();
          }
        });
      }
    };

    _this.registerInputToAllowEvents = function (input) {
      _this.setState({
        inputToAllowEvents: input
      });
    };

    _this.getSelectedElements = function () {
      var selected = _this.getSelected();

      var _this$props = _this.props,
          hasArrowIcon = _this$props.hasArrowIcon,
          illustrationOnly = _this$props.illustrationOnly,
          shouldTranslate = _this$props.shouldTranslate,
          customSelectedText = _this$props.customSelectedText;
      var smallArrow = _this.props.skin === 'dark';

      if (props.multiSelect) {
        var _isPlaceholder = selected.length === 0 && _this.props.placeholder;

        var content;

        if (_isPlaceholder) {
          content = _this.props.placeholder; // eslint-disable-next-line wix-editor/prefer-ternary
        } else if (customSelectedText) {
          content = customSelectedText;
        } else {
          content = _.map(selected, function (option) {
            return getSelectedKeyAndChild(option, true).child;
          }).join(', ');
        }

        return /*#__PURE__*/React.createElement(Selected, {
          key: 'selected',
          isPlaceholder: _isPlaceholder,
          hasArrowIcon: hasArrowIcon,
          illustrationOnly: illustrationOnly,
          smallArrow: smallArrow,
          shouldTranslate: shouldTranslate
        }, /*#__PURE__*/React.createElement(SelectedTextContainer, {
          value: content
        }));
      }

      var shouldRenderSearchBox = _this.props.searchBox && _this.state.isOpen;

      var _getSelectedKeyAndChi = getSelectedKeyAndChild(selected, shouldRenderSearchBox),
          key = _getSelectedKeyAndChi.key,
          child = _getSelectedKeyAndChi.child;

      if (shouldRenderSearchBox) {
        return /*#__PURE__*/React.createElement(SearchBox, {
          key: key,
          hasArrowIcon: hasArrowIcon,
          illustrationOnly: illustrationOnly,
          smallArrow: smallArrow,
          shouldTranslate: shouldTranslate,
          value: getOptionsLabel(_this.state.foundOption) || _this.state.searchTerm,
          searchTerm: _this.state.searchTerm,
          selectedValue: child,
          onChange: _this.onSearch,
          registerInputToAllowEvents: _this.registerInputToAllowEvents,
          placeholder: _this.props.placeholder,
          onKeyDown: _this.props.onSearchKeyDown
        });
      }

      var isPlaceholder = _this.props.placeholder && selected === _this.props.placeholder;
      var customText = isPlaceholder && _this.props.placeholder || customSelectedText;
      return /*#__PURE__*/React.createElement(Selected, {
        key: key || 'selected',
        isPlaceholder: isPlaceholder,
        hasArrowIcon: hasArrowIcon,
        illustrationOnly: illustrationOnly,
        smallArrow: smallArrow,
        shouldTranslate: shouldTranslate
      }, customText ? /*#__PURE__*/React.createElement(SelectedTextContainer, {
        value: customText
      }) : child);
    };

    _this.toggleOptions = function (isOpen) {
      _this.setState({
        isOpen: _.isUndefined(isOpen) ? !_this.state.isOpen : isOpen
      });
    };

    _this.state = {
      isOpen: false,
      optionsStyle: {},
      optionsInnerStyle: {},
      visibleOptionsIndexes: [],
      wasVisibleOptionsIndexes: [],
      candidateIndex: _.indexOf(_this.getOptions(), _this.getSelected()),
      searchTerm: '',
      isExtraLabel: false,
      narrowViewport: false
    };

    _this.getValueByIndex = function (index) {
      return getOptionsValue(_this.getOptions()[index]);
    };

    _this.getIsDisabledByIndex = function (index) {
      return isOptionsDisabled(_this.getOptions()[index]);
    };

    _this.getIsSelectableByIndex = function (index) {
      return !(_.isUndefined(_this.getValueByIndex(index)) || _this.getIsDisabledByIndex(index));
    };

    _this.getNewIndex = function (by) {
      var index = _this.state.candidateIndex;
      var originalIndex = index;
      var min = 0;
      var max = _this.getOptions().length - 1;

      do {
        index += by;
      } while (!_this.getIsSelectableByIndex(index) && index >= 0 && index <= max);

      return index === max + Math.abs(by) || index === min - Math.abs(by) ? originalIndex : index;
    };

    _this.scrollOptionsNode = function (optionsNode, deltaY) {
      if (!_this.customBlockScroll(optionsNode, deltaY)) {
        optionsNode.scrollTop += deltaY;
      }
    };

    _this.scrollToActive = function (enforce) {
      if (_this.activeOption) {
        var activeNode = ReactDOM.findDOMNode(_this.activeOption);
        var optionsNode = activeNode.parentElement;

        if (enforce) {
          optionsNode.scrollTop = activeNode.offsetTop;
        }

        var optionsScrollTop = optionsNode.scrollTop;
        var activeNodeBottom = activeNode.offsetTop + activeNode.offsetHeight;
        var visibleBottom = optionsScrollTop + optionsNode.offsetHeight;

        if (activeNodeBottom > visibleBottom) {
          _this.scrollOptionsNode(optionsNode, activeNodeBottom - visibleBottom);
        } else if (activeNode.offsetTop < optionsScrollTop) {
          _this.scrollOptionsNode(optionsNode, activeNode.offsetTop - optionsScrollTop);
        }
      }
    };

    _this.onKeyDown = function (e, isOpen) {
      if (isOpen) {
        if (e.keyCode === KEYS.UP || e.keyCode === KEYS.DOWN) {
          var incrementBy = e.keyCode === KEYS.UP ? -1 : 1;

          var candidateIndex = _this.getNewIndex(incrementBy);

          if (_this.props.onArrowKeyDown) {
            _this.props.onArrowKeyDown(_this.getOptions()[candidateIndex]);
          }

          _this.setState({
            candidateIndex: candidateIndex
          }, _this.scrollToActive);
        } else if (e.keyCode === KEYS.ENTER || e.keyCode === KEYS.SPACE && !_this.props.searchBox) {
          if (_this.state.isExtraLabel) {
            _this.props.onAddExtraStringOption(_this.state.searchTerm);
          } else {
            _(_this.state.candidateIndex).thru(_this.getValueByIndex).thru(onChangeValue).value();
          }
        }
      }
    };

    var updateScrollCache = function updateScrollCache(optionsNode, deltaY) {
      var remainingScroll = optionsNode.scrollHeight - optionsNode.offsetHeight;
      _this.scrollCache += Math.min(Math.abs(deltaY), remainingScroll);

      _this.onOptionsLayoutChange(_this.lastOptionsBoundingRect, optionsNode);
    };

    _this.scrollCache = 0;

    _this.customBlockScroll = function (optionsNode, deltaY) {
      if (_this.props.searchBox) {
        return false;
      }

      var optionsRect = optionsNode.getBoundingClientRect();
      var remainingScroll = optionsNode.scrollHeight - optionsNode.offsetHeight;
      var indentFromEdge = dropDownPositionUtil.CONSTS.INDENT_FROM_EDGE;
      var maxAllowedHeight = dropDownPositionUtil.getViewportSize().height - indentFromEdge * 2;

      if (optionsNode.offsetHeight < maxAllowedHeight && remainingScroll > 0) {
        if (deltaY > 0 && optionsRect.top > indentFromEdge) {
          updateScrollCache(optionsNode, deltaY);
          return true;
        } else if (deltaY < 0 && optionsRect.bottom < maxAllowedHeight + indentFromEdge) {
          updateScrollCache(optionsNode, deltaY);
          return true;
        }
      }
    };

    var updateOptionsVisibility = function updateOptionsVisibility(scrollTop) {
      var OFFSET = 30;
      var height = _this.state.optionsInnerStyle.height || _this.state.optionsStyle.height;

      var visibleOptionsIndexes = _(_this.optionsY).map(function (y, i) {
        return scrollTop - OFFSET < y && y < scrollTop + height + OFFSET ? i : null;
      }).filter(function (i) {
        return i !== null;
      }).value();

      var wasVisibleOptionsIndexes = _.union(_this.state.wasVisibleOptionsIndexes, visibleOptionsIndexes);

      _this.setState({
        visibleOptionsIndexes: visibleOptionsIndexes,
        wasVisibleOptionsIndexes: wasVisibleOptionsIndexes
      });
    };

    _this.onOptionsScroll = function (e) {
      if (_this.props.shouldPassIsVisibleToOptions) {
        updateOptionsVisibility(e.target.scrollTop);
      }
    };

    var getStickyFooterHeight = function getStickyFooterHeight() {
      return _this.stickyFooter ? ReactDOM.findDOMNode(_this.stickyFooter).offsetHeight : 0;
    };

    var getStickyFooterStyle = function getStickyFooterStyle(optionsHeight, stickyFooterHeight) {
      return stickyFooterHeight ? {
        height: optionsHeight - stickyFooterHeight
      } : {};
    };

    var getOptionsRect = function getOptionsRect(currentBoundingRect, stickyFooterHeight) {
      var optionsRect = getRectByBoundingRect(currentBoundingRect);
      optionsRect.height += stickyFooterHeight;
      return optionsRect;
    };

    _this.onOptionsLayoutChange = function (optionsBoundingRect, optionsNode) {
      if (!optionsBoundingRect || !_this.wrappedSelectedOption) {
        _this.scrollCache = 0;
      }

      _this.lastOptionsBoundingRect = optionsBoundingRect;

      if (optionsBoundingRect) {
        var viewport = dropDownPositionUtil.getViewportSize();
        var selectedRect = getRectByReactElement(_assertThisInitialized(_this));
        var stickyFooterHeight = getStickyFooterHeight();
        var optionsRect = getOptionsRect(optionsBoundingRect, stickyFooterHeight);
        var selectedOptionsNode = getNodeByRefIfExist(_this.wrappedSelectedOption);
        var selectedOptionY = !_this.props.searchBox && _this.props.openOnSelected && selectedOptionsNode ? selectedOptionsNode.offsetTop || 0 : null;
        var optionsMaxHeight = _this.props.optionsMaxHeight || null;
        var params = {
          longerByScroll: _this.scrollCache,
          selectedOptionY: selectedOptionY,
          optionsMaxHeight: optionsMaxHeight
        };
        var optionsPosition = dropDownPositionUtil.getOptionsPosition(viewport, selectedRect, optionsRect, params);
        var stickyFooterStyle = getStickyFooterStyle(optionsPosition.height, stickyFooterHeight);
        var hiddenScrollStyle = _this.props.hiddenScroll && !_this.props.searchBox ? getHiddenScrollStyle(optionsNode) : {};

        _this.setState({
          optionsStyle: getStyleByRect(optionsPosition),
          optionsInnerStyle: _.assign({}, hiddenScrollStyle, stickyFooterStyle)
        }, function () {
          var selectedOptionsRect = selectedOptionsNode ? getRectByBoundingRect(selectedOptionsNode.getBoundingClientRect()) : {};
          var shouldAutoScroll = !_this.scrollCache && selectedOptionY > 0 && optionsNode.scrollTop === 0 && selectedRect.y !== selectedOptionsRect.y;

          if (shouldAutoScroll) {
            optionsNode.scrollTop = selectedOptionsRect.y - selectedRect.y;
          } else if (_this.props.shouldPassIsVisibleToOptions) {
            updateOptionsVisibility(optionsNode.scrollTop);
          }
        });
      }
    };

    _this.getOptionsContainerClassName = function () {
      var narrowViewport = _this.state.narrowViewport;
      return _.compact([_this.props.optionsContainerClassName, _this.props.skin === 'dark' ? 'dark-skin' : '', _this.props.componentUIColor === 'ORANGE' ? 'orange-colors' : '', _this.props.hiddenScroll && !_this.props.searchBox ? 'hidden-scroll' : null, narrowViewport ? 'narrow-viewport' : null]).join(' ');
    };

    _this.getDropDownBaseClasses = function () {
      return _.compact(['control-dropdown', _this.props.hiddenScroll && !_this.props.searchBox ? 'hidden-scroll' : '', _this.props.componentUITheme === 'LIGHT' ? 'light-theme' : '', _this.props.componentUIColor === 'ORANGE' ? 'orange-colors' : '', _this.props.skin === 'dark' ? 'dark-skin' : '']).join(' ');
    };

    return _this;
  }

  _createClass(DropDown, [{
    key: "_checkForNarrowViewPort",
    value: function _checkForNarrowViewPort() {
      var narrowViewport = dropDownPositionUtil.getViewportSize().width <= dropDownPositionUtil.CONSTS.NARROW_VIEWPORT;
      this.setState({
        narrowViewport: narrowViewport
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkForNarrowViewPort();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      this._checkForNarrowViewPort();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(DropDownBase, {
        ref: "dropDownBase",
        automationId: this.props.automationId,
        className: this.props.getClassName(this.getDropDownBaseClasses()),
        disabled: this.props.disabled,
        blockScroll: true,
        onToggle: this.props.onToggle,
        selected: this.getSelectedElements(),
        optionsStyle: this.state.optionsStyle,
        optionsInnerStyle: this.state.optionsInnerStyle,
        onLayoutChange: this.onOptionsLayoutChange,
        onKeyDown: this.onKeyDown,
        onOptionsScroll: this.onOptionsScroll,
        customBlockScroll: this.customBlockScroll,
        customToggle: this.toggleOptions,
        optionsContainerClassName: this.getOptionsContainerClassName(),
        inputToAllowEvents: this.state.inputToAllowEvents,
        customCloseKeys: this.getCloseKeys(),
        displayArrow: !this.props.searchBox,
        isOpen: this.state.isOpen,
        keepOptionsWidth: true,
        options: this.getOptionsElements(),
        dataLabel: this.props.dataLabel,
        forceOpen: this.props.forceOpen,
        dataHook: this.props.dataHook
      });
    }
  }]);

  return DropDown;
}(React.Component);

DropDown.displayName = 'DropDown';
DropDown.propTypes = {
  /** Controls the selected option, based on the option values */
  value: PropTypes.any,

  /** Callback called with the selected option value */
  onChange: PropTypes.func,

  /** expects "DropDownOption" nodes in the format fo <DropDownOption value="unique-value" label="presentational value"/> */
  children: PropTypes.arrayOf(PropTypes.any),

  /** Sets the component in disabled mode */
  disabled: PropTypes.bool,

  /** Displays a placeholder when no option is selected */
  placeholder: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]),

  /** Gives a unique look for custom options. can take: "detailed-dropdown-options" or "themes-dropdown-options" */
  optionsContainerClassName: PropTypes.string,
  options: dropDownHelpers.PropTypes.options,
  onOptionMouseEnter: PropTypes.func,
  onArrowKeyDown: PropTypes.func,
  onToggle: PropTypes.func,

  /** Callback which is called when a user presses a key in searchBox. Parameter - Keyboard event */
  onSearchKeyDown: PropTypes.func,
  hasArrowIcon: PropTypes.bool,
  hiddenScroll: PropTypes.bool,
  illustrationOnly: PropTypes.bool,
  openOnSelected: PropTypes.bool,

  /** Allow a user to search by dropdown values */
  searchBox: PropTypes.bool,
  shouldPassIsVisibleToOptions: PropTypes.bool,
  groupedOptions: PropTypes.bool,
  callOnChangeAnyway: PropTypes.bool,
  dataLabel: PropTypes.string,
  forceOpen: PropTypes.bool,
  skin: PropTypes.string,
  componentUIColor: PropTypes.oneOf(['BLUE', 'ORANGE']),
  componentUITheme: PropTypes.oneOf(['DARK', 'LIGHT']),
  optionsMaxHeight: PropTypes.number,
  allowAddExtraStringOptions: PropTypes.bool,
  onAddExtraStringOption: PropTypes.func,
  multiSelect: PropTypes.bool,

  /** Set a custom selected text value. Can be used to achieve an "All Selected" case */
  customSelectedText: PropTypes.string,
  tooltipContent: PropTypes.node
};
DropDown.defaultProps = {
  disabled: false,
  hasArrowIcon: true,
  hiddenScroll: true,
  openOnSelected: true,
  searchBox: false,
  shouldPassIsVisibleToOptions: false,
  groupedOptions: false,
  optionsContainerClassName: '',
  callOnChangeAnyway: false,
  skin: '',
  allowAddExtraStringOptions: false,
  multiSelect: false,
  onAddExtraStringOption: function onAddExtraStringOption() {},
  illustrationOnly: false
};
export default compose(DropDown);